import ptCommon from './pt/common.json';
import ptLanding from './pt/landing.json';
import ptTerms from './pt/terms.json';
import ptPrivacy from './pt/privacy.json';
import ptAchievements from './pt/achievements.json';
import enCommon from './en/common.json';
import enLanding from './en/landing.json';
import enTerms from './en/terms.json';
import enPrivacy from './en/privacy.json';
import enAchievements from './en/achievements.json';
import esCommon from './es/common.json';
import esLanding from './es/landing.json';
import esTerms from './es/terms.json';
import esPrivacy from './es/privacy.json';
import esAchievements from './es/achievements.json';

export const resources = {
  pt: { common: ptCommon, landing: ptLanding, terms: ptTerms, privacy: ptPrivacy, achievements: ptAchievements },
  en: { common: enCommon, landing: enLanding, terms: enTerms, privacy: enPrivacy, achievements: enAchievements },
  es: { common: esCommon, landing: esLanding, terms: esTerms, privacy: esPrivacy, achievements: esAchievements },
};

export const SUPPORTED_LANGUAGES = ['pt', 'en', 'es'];
